import { render, staticRenderFns } from "./CourseList.vue?vue&type=template&id=4a4fca45&"
import script from "./CourseList.vue?vue&type=script&lang=ts&"
export * from "./CourseList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports